import { useState, useEffect, useCallback } from "react";
import { isTokenExpired } from "../services/jwt";
import { useNavigate } from "react-router-dom";
import { OrderDetails } from "../interface/interfaces";
import { addToCartAPi } from "../api/requests";



export function useAuthLogic() {
  const navigate = useNavigate();
  const [authVersion, setAuthVersion] = useState(0);

  const [token, setToken] = useState<string | null>(() => {
    const stored = localStorage.getItem("token");
    if (stored && isTokenExpired(stored)) {
      localStorage.removeItem("token");
      return null;
    }
    return stored;
  });

  const [afterAuthRedirect, setAuthRedirect] = useState({
    pageUrl: "",
  });

    const saveExistingCart = async () => {
    try {
       const stored = localStorage.getItem("cart_products");
      const existing_cart: OrderDetails[] = stored ? JSON.parse(stored) : [];

      const promises=[]

      for (let index = 0; index < existing_cart.length; index++) {
        const elem = existing_cart[index];

        let color='',size=''


        let colorProp=elem.selectedProperties?.find((data)=>{
             return data.type==='color'
        })
        if(colorProp){
           color=colorProp.value
        }


         let sizeProp=elem.selectedProperties?.find((data)=>{
             return data.type==='size'
        })
        if(sizeProp){
           size=sizeProp.value
        }

        promises.push(addToCartAPi(elem.productId,size,color,elem.quantity))

      }

      await Promise.all(promises)
  

     localStorage.setItem("cart_products", JSON.stringify([]));

     setAuthVersion((v) => v + 1);

    } catch (error:any) {
      console.error(error)
    }

  };


  const authLogin = async (jwt: string) => {
    try {
      const parts = jwt.split(".");
      if (parts.length !== 3) throw new Error("Malformed token");

      const payload = JSON.parse(atob(parts[1]));
      const decodedExp = payload.exp;

      if (!decodedExp) throw new Error("No exp field in token");

      const expiryTime = decodedExp * 1000;
      const now = Date.now();

      if (expiryTime <= now) {
        console.warn("Token has expired.");
        logout();
        return;
      }

      localStorage.setItem("token", jwt);
      setToken(jwt);

      // console.log(
      //   "Token is valid. Expires at:",
      //   new Date(expiryTime).toLocaleString()
      // );
      
      await saveExistingCart()



      if (afterAuthRedirect && afterAuthRedirect.pageUrl !== "") {
        navigate(afterAuthRedirect.pageUrl);
      } else {
        navigate("/");
      }


    } catch (error) {}
  };

  const logout = () => {
    localStorage.removeItem("token");
    setToken(null);
    
  };

  const isLoggedIn = useCallback((): boolean => {
    return token !== null && !isTokenExpired(token);
  }, [token]);


  // Auto logout when token expires
  useEffect(() => {
    if (!token) return;

    try {
      const parts = token.split(".");
      if (parts.length !== 3) throw new Error("Malformed token");

      const payload = JSON.parse(atob(parts[1]));
      const decodedExp = payload.exp;

      if (!decodedExp) throw new Error("No exp field in token");

      const expiryTime = decodedExp * 1000;
      const now = Date.now();

      if (expiryTime <= now) {
        console.warn("Token has expired.");
        logout();
        return;
      }
    } catch (error) {
      console.error("Invalid or unauthentic token:", error);
      logout();
    }
  }, [token]);

  return { token, authLogin, logout, isLoggedIn, setAuthRedirect,authVersion};
}


